import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, MailCheck, MailX } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

export const InboxTab = () => {
  const [letters, setLetters] = useState([]);

  const load = async () => {
    const { data } = await api.get("/admin/contacts");
    setLetters(data);
  };

  useEffect(() => { load().catch((e) => toast.error(formatApiError(e))); }, []);

  const remove = async (l) => {
    try {
      await api.delete(`/admin/contacts/${l.id}`);
      setLetters((prev) => prev.filter((x) => x.id !== l.id));
      toast.success("Letter burned.");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div data-testid="cms-inbox-list">
      <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#78716c] mb-6">
        {letters.length} letters received
      </p>
      <div className="space-y-4">
        {letters.map((l) => (
          <div key={l.id} className="border border-[#232530] bg-[#0d0e12] p-6" data-testid={`inbox-letter-${l.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="font-serif text-lg text-[#ede8e1]">{l.subject}</p>
                <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#78716c] mt-1">
                  {l.name} — {l.email} — {new Date(l.created_at).toLocaleString("en-GB")}
                </p>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                {l.emailed
                  ? <span className="flex items-center gap-1.5 font-mono text-[10px] tracking-[0.2em] uppercase text-[#581313]"><MailCheck size={14} /> Dispatched</span>
                  : <span className="flex items-center gap-1.5 font-mono text-[10px] tracking-[0.2em] uppercase text-[#78716c]"><MailX size={14} /> Vault only</span>}
                <button onClick={() => remove(l)} className="text-[#a8a29e] hover:text-[#581313] transition-colors" data-testid={`inbox-delete-${l.id}`}>
                  <Trash2 size={16} />
                </button>
              </div>
            </div>
            <p className="mt-4 text-[#a8a29e] font-light whitespace-pre-wrap border-l-2 border-[#581313] pl-4">{l.message}</p>
          </div>
        ))}
        {letters.length === 0 && (
          <p className="py-12 text-center font-mono text-xs tracking-[0.3em] uppercase text-[#57534e]">No letters yet. The dark is quiet.</p>
        )}
      </div>
    </div>
  );
};
